import React, { useState, useEffect } from 'react';
import { Clock3, CalendarDays, Repeat, Star, User } from 'lucide-react';
import BottomNavigationCustomer from './BottomNavigatonCustomer';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../../Assets/navbar/logo.svg';
import { Eye, Download,ArrowLeft } from 'lucide-react';
import axios from 'axios';
import Loading from '../../../Component/Customers/Cards/Loading';

const CustomerInvoices = () => {
    const navigate = useNavigate();
    const [selectedFilter, setSelectedFilter] = useState('completed');
    const [pastTrips, setPastTrips] = useState([]);
    const [loading, setLoading] = useState(true);

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                setLoading(true);
                const services = ['crane', 'recoveryVan'];
                let allInvoices = [];

                for (const service of services) {
                    const response = await axios.get(
                        `${process.env.REACT_APP_BACKEND_URL}/api/getPersonalAccidentVehicleInfoById/${userId}/${service}/not_defined`,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        }
                    );

                    if (response.data.message !== "No accident vehicle data found." && response.data.data) {
                        const filteredData = response.data.data
                            .filter((info) =>
                                info?.[`${service}Details`]?.confirmDoneWorkingTime &&
                                info?.[`${service}Details`]?.confirmDoneWorking === 1 &&
                                info?.[`${service}Details`]?.customerAcceptedVendor === 1 &&
                                info?.[`${service}Details`]?.cancelOrder === 0 &&
                                info?.[`${service}Details`]?.cancelPreAssignOrder === 0 &&
                                info?.[`${service}Details`]?.completeOrder === 1
                            )
                            .sort((a, b) =>
                                new Date(b?.[`${service}Details`]?.confirmDoneWorkingTime) -
                                new Date(a?.[`${service}Details`]?.confirmDoneWorkingTime)
                            )
                            .map((item) => {
                                const details = item?.[`${service}Details`];
                                const createdDate = new Date(details?.confirmDoneWorkingTime);

                                // Debug: Log the details to see all available fields
                                console.log('Invoice details:', details);

                                return {
                                    id: item.id,
                                    title: service
                                        .replace(/([A-Z])/g, ' $1')
                                        .replace(/^./, (str) => str.toUpperCase())
                                        .trim() + ' Service',
                                    vehicleNo: details?.vehicleNo,
                                    date: createdDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }),
                                    time: createdDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }),
                                    amount: details?.charges || '₹0.00',
                                    invoiceUrl: details?.systemCreatedInvoice,
                                    image: details?.images?.['Front Right'],
                                };
                            });

                        allInvoices = [...allInvoices, ...filteredData];
                    }
                }

                // Sort all invoices by date
                allInvoices.sort((a, b) => new Date(b.date) - new Date(a.date));
                setPastTrips(allInvoices);
            } catch (error) {
                console.error('Error fetching invoices:', error);
                setPastTrips([]);
            } finally {
                setLoading(false);
            }
        };

        if (token && userId) {
            fetchInvoices();
        }
    }, [token, userId]);

    const filteredTrips = pastTrips.filter((trip) =>
        selectedFilter === 'completed' ? !trip.cancelled : trip.cancelled
    );
    return (
        <div className="max-w-md mx-auto font-satoshi mb-3">

            <div onClick={() => navigate(-1)} className='top-5 left-1 cursor-pointer'>
                <ArrowLeft />
            </div>
            <div className='p-4 mb-5'>

                <h1 className="text-3xl mt-[3rem] font-bold mb-4">Your Invoices</h1>

                {/* Loading State */}
                {loading ? (
                    <div className="flex justify-center items-center py-10">
                        <Loading />
                    </div>
                ) : filteredTrips.length === 0 ? (
                    <div className="text-center text-gray-400 py-10">
                        No invoices found
                    </div>
                ) : (
                    <section>
                        {filteredTrips.map((trip) =>
                            <div
                                key={trip.id}
                                className="bg-white rounded-xl border mb-2 p-4 shadow-sm w-full"
                            >
                                <div className="flex items-center gap-3">
                                    <div className="w-[5rem] h-[5rem] rounded-full bg-gray-200 flex items-center justify-center overflow-hidden flex-shrink-0">
                                        {trip.image ? (
                                            <img 
                                                src={trip.image} 
                                                alt="vehicle" 
                                                className="w-full h-full object-cover"
                                            />
                                        ) : (
                                            <span className="text-xs font-bold text-gray-600">Invoice</span>
                                        )}
                                    </div>
                                    <div className="flex-1">
                                        <div className="font-semibold my-2">{trip.title}</div>
                                        <div className="font-semibold text-gray-500 my-2 text-sm">{trip.vehicleNo}</div>

                                        <div className="text-sm text-gray-500">
                                            {trip.date} • {trip.time}
                                        </div>
                                        <div className="text-sm text-gray-600 font-bold my-2">
                                            {trip.amount}
                                        </div>
                                        <div className="flex w-full space-x-4">
                                            <button
                                                onClick={() => {
                                                    if (trip.invoiceUrl) {
                                                        const link = document.createElement('a');
                                                        link.href = trip.invoiceUrl;
                                                        link.download = '';
                                                        link.target = '_blank';
                                                        document.body.appendChild(link);
                                                        link.click();
                                                        document.body.removeChild(link);
                                                    }
                                                }}
                                                className="flex items-center gap-2 hover:bg-green-500 text-gray-600 rounded-lg px-2 py-2"
                                            >
                                                <Download className="h-5 w-5 text-green-400" />
                                                <span className="text-sm">Invoice Download</span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        )}

                    </section>
                )}



            </div>

        </div>
    );
};

export default CustomerInvoices;
